import { WebsiteConfig } from "../../../types/WebsiteConfig";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { Ping } from "../../../types/Ping";

class WebsiteAPI {
    GetConfiguration(clientWebsiteId: string): Promise<WebsiteConfig> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/websites/${clientWebsiteId}`));
    }

    Ping(): Promise<Ping> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, `/api/ping`, { _: new Date().getTime() }));
    }
}

export { WebsiteAPI }
